import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-formularios',
  templateUrl: './formularios.component.html',
  styleUrls: ['./formularios.component.css']
})
export class FormulariosComponent implements OnInit {
  code:string = "<div *ngIf='users.length == 0 && !loading'></div>";
  code1:string = "<div *ngFor='let user of users; let idx = index'> {{user.nombre + ' ' + idx}} </div>";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Utilidades/formularios/formularios.component.ts